import 'PlattixUI/extensions/date.extensions'

export const Slugs = {
    Developer: '/Developer',
    Admin: '/Admin',
    Account: '/Account',
    Acc: 'Acc',
    EnergytixSolutions: '/ES',
    Promotional: {
        Lovitas: '/Lovitas',
    },
};

export const NotificationsPath = '/Notifications';

export const NotificationsRouteMap = {
    overview: NotificationsPath,
}
